import { useEffect, useRef, useCallback } from 'react';
import useTrackEvent from '../useTrackEvent';

// Define scroll depth thresholds in percentage
const SCROLL_THRESHOLDS = [25, 50, 75, 100];

const useScrollTrack = () => {
  const trackEvent = useTrackEvent();

  // Keep track of which thresholds have already been triggered
  const triggered = useRef<number[]>([]);

  const handleScroll = useCallback(() => {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrolledPercent = Math.floor((scrollTop / docHeight) * 100);

    SCROLL_THRESHOLDS.forEach((threshold) => {
      if (scrolledPercent >= threshold && !triggered.current.includes(threshold)) {
        triggered.current.push(threshold);
       // tracking event
        trackEvent({
          action: 'scroll_depth_reached',
          label: 'Percentage',
          value: `${threshold}%`,
        });
      }
    });
  }, [trackEvent]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);
};

export default useScrollTrack;